export default __webpack_public_path__ + "static/media/phat-nguyen.833a686e.jpg";